import { render, staticRenderFns } from "./OskefuCG.vue?vue&type=template&id=2b201c59&scoped=true"
import script from "./OskefuCG.vue?vue&type=script&lang=js"
export * from "./OskefuCG.vue?vue&type=script&lang=js"
import style0 from "./OskefuCG.vue?vue&type=style&index=0&id=2b201c59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b201c59",
  null
  
)

export default component.exports